export default function webhooks(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT_WEBHOOK':
            return {
                ...state,
                webhook: action.webhook,
            }
        case 'CLEAR_CURRENT_WEBHOOK':
            return {
                ...state,
                webhook: null,
            }
        default:
            return state;
    }
}
